var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fromEvent } from 'rxjs';
import { debounceTime, map, filter } from 'rxjs/operators';
import IntlTelInput from 'intl-tel-input';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import WithRender from './TelephoneInput.html';
export var TELEPHONE_NUMBER_STATUS;
(function (TELEPHONE_NUMBER_STATUS) {
    TELEPHONE_NUMBER_STATUS[TELEPHONE_NUMBER_STATUS["VALID_NUMBER"] = 0] = "VALID_NUMBER";
    TELEPHONE_NUMBER_STATUS[TELEPHONE_NUMBER_STATUS["INVALID_COUNTRY_CODE"] = 1] = "INVALID_COUNTRY_CODE";
    TELEPHONE_NUMBER_STATUS[TELEPHONE_NUMBER_STATUS["TOO_SHORT"] = 2] = "TOO_SHORT";
    TELEPHONE_NUMBER_STATUS[TELEPHONE_NUMBER_STATUS["TOO_LONG"] = 3] = "TOO_LONG";
    TELEPHONE_NUMBER_STATUS[TELEPHONE_NUMBER_STATUS["NOT_A_NUMBER"] = 4] = "NOT_A_NUMBER";
})(TELEPHONE_NUMBER_STATUS || (TELEPHONE_NUMBER_STATUS = {}));
;
// TODO:
// 1. Load dial code by user's IP address if not provided.
// 2. User types
let TelephoneInput = class TelephoneInput extends Vue {
    // TODO:
    // 1. Load dial code by user's IP address if not provided.
    // 2. User types
    constructor() {
        super(...arguments);
        this.telephoneNumber = '';
    }
    // TODO: Pending work for other states
    get classes() {
        // User will set this flag to true with the help of 'isValidNumber' flag or any other required criteria.
        // So it will be controlled by the user when the error should be shown.
        return {
            'telephone-input--error': this.error
        };
    }
    isValidNumber() {
        return !this.telInputInstance || this.telInputInstance.isValidNumber();
    }
    mounted() {
        this.createTelephoneInputInstance().then(() => {
            this.updateTelephoneNumber();
            this.emitTelephoneNumber();
        });
        const stream = fromEvent(this.$refs.telephoneInput, 'input').pipe(debounceTime(300), map((x) => x.target), map((target) => target.value.trim()), filter((value) => value !== this.telephoneNumber));
        // Emit the `input` event after idle time of 300ms when user stops typing.
        this.telephoneInputSub = stream.subscribe((value) => {
            this.onNumberInput(value);
        });
    }
    onValueUpdate() {
        const dialCode = this.telInputInstance.getSelectedCountryData().dialCode;
        // Update input only when there is a change in value.
        if ((Number(dialCode) !== this.value.dialCode) || this.telephoneNumber !== this.value.dialNumber) {
            this.updateTelephoneNumber();
        }
    }
    onNumberInput(enteredNumber) {
        this.telephoneNumber = enteredNumber;
        this.emitTelephoneNumber();
    }
    onCountryChange($event) {
        const newCountryCode = Number($event.target.previousSibling.innerText);
        // Emit number only when there is actually difference between old and new country code.
        if (newCountryCode !== this.value.dialCode) {
            this.emitTelephoneNumber();
        }
    }
    createTelephoneInputInstance() {
        return __awaiter(this, void 0, void 0, function* () {
            this.telInputInstance = new IntlTelInput(this.$refs.telephoneInput, {
                separateDialCode: true,
                utilsScript: yield import('intl-tel-input/build/js/utils.js')
            });
        });
    }
    emitTelephoneNumber() {
        const selectedCountry = this.telInputInstance.getSelectedCountryData();
        const telephoneNumber = {
            dialCode: Number(selectedCountry.dialCode),
            dialNumber: this.telephoneNumber,
            isValid: this.isMandatory
                ? this.isValidNumber()
                : this.telephoneNumber.trim() !== '' ? this.isValidNumber() : true,
            errorCode: this.telInputInstance.getValidationError()
        };
        this.$emit('input', telephoneNumber);
    }
    updateTelephoneNumber() {
        let telNumber = '';
        if (this.value.dialCode) {
            telNumber = `+${this.value.dialCode.toString()}`;
        }
        if (this.value.dialNumber) {
            telNumber += this.value.dialNumber;
            this.telephoneNumber = this.value.dialNumber;
        }
        this.telInputInstance.setNumber(telNumber);
    }
};
__decorate([
    Prop({ default: () => ({ dialNumber: '' }) }),
    __metadata("design:type", Object)
], TelephoneInput.prototype, "value", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TelephoneInput.prototype, "error", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], TelephoneInput.prototype, "isMandatory", void 0);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TelephoneInput.prototype, "onValueUpdate", null);
TelephoneInput = __decorate([
    WithRender,
    Component({})
], TelephoneInput);
export default TelephoneInput;
//# sourceMappingURL=TelephoneInput.js.map